module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-item"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "item-content"
  }, [_c('Grid', {
    attrs: {
      "loading": _vm.loading,
      "data": _vm.gridOption.data,
      "columns": _vm.gridOption.columns
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-title"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("已获取学生信息")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b74f5016!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/test.vue
// module id = 156
// module chunks = 2